<template>
  <div id="main-box" class="page-content" :class="{bottom:list.length > 0}">
    <div class="table-box layui-body" style="left:0;">
      <div class="xblock layui-form">
        <div class="layui-input-inline xblock-row">
          <input type="text" name="username" placeholder="手机号搜索" v-on:keydown.13="get_recharge_record(true)"
            v-model="phone" autocomplete="off" class="layui-input" />
        </div>
        <div class="layui-input-inline xblock-row">
          <input type="text" name="username" placeholder="用户ID搜索" v-on:keydown.13="get_recharge_record(true)"
            v-model="uid" autocomplete="off" class="layui-input" />
        </div>
        <div class="layui-input-inline xblock-row">
          <input type="text" name="username" placeholder="邀请人ID搜索" v-on:keydown.13="get_recharge_record(true)"
            v-model="p_uid" autocomplete="off" class="layui-input" />
        </div>
        <div class="layui-input-inline country_select nav-btn xblock-row">
          <select name="status" lay-verify="required" lay-filter="type_select">
            <option :value="item.id" v-for="item in PackageType">{{ item.name }}</option>
          </select>
        </div>
        <div class="layui-input-inline xblock-row">
          <input type="text" class="layui-input" id="order_date" placeholder=" - " autocomplete="off" />
        </div>
        <button class="layui-btn xblock-row" style="height: 36px;" lay-filter="sreach"
          v-on:click="get_recharge_record(true)"><i class="fa fa-search"></i></button>
        <div class="x-right xblock-row">
          <span class="x-right" v-text="'　共有数据：'+count+ '条'"></span>
          <span class="x-right" v-text="'积分：'+integral+ '元　|　'"></span>
          <span class="x-right" v-text="'余额：'+money+ '元　|　'"></span>
        </div>
        <div class="clear-both"></div>
      </div>

      <table class="layui-table layui-form">
        <thead>
          <tr>
            <th>编号</th>
            <th>角色</th>
            <th>邀请人</th>
            <th>手机号</th>
            <th>积分</th>
            <th>余额</th>
            <th>上架返利</th>
            <th>最后在线时间</th>
            <th>创建时间</th>
          </tr>
        </thead>
        <tbody>
          <tr class="order_box" v-for="(item,index) in list" v-bind:key="index"
            :class="[{cancel_box:item.status == 1},{shipping_box:item.status == 2}]">
            <td v-text="item.id"></td>
            <td>
              <i v-if="item.role == 10">管理员</i>
              <i v-else-if="item.role == 20">货代</i>
              <i v-else-if="item.role == 30">用户</i>
            </td>
            <td>
              <i v-if="item.parent_id" v-text="item.parent_id"></i>
              <i v-else>-</i>
            </td>
            <td v-text="item.username"></td>
            <td>
              <i v-text="item.integral" v-if="item.integral < 0" style="font-weight:bold;" class="redColor"></i>
              <i v-text="item.integral" v-else></i>
            </td>
            <td v-text="item.money"></td>
            <td>
              <input type="checkbox" class="rebate" :checked="item.is_distribution" :data-uid="item.id" name="rebate"
                lay-skin="switch" lay-text="是|否" lay-filter="rebate">
            </td>
            <td v-text="item.last_at"></td>
            <td v-text="item.created_at"></td>
          </tr>
        </tbody>
      </table>

      <!-- transition -->
      <K-Transition v-if="list.length < 1"></K-Transition>

    </div>

    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
  var self, form, layer, laypage, laydate;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'MemberRechargeLog',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
    },
    data() {
      return {
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        page: 1,
        count: 0,
        money: 0,
        integral: 0,
        page_num: 20,
        current_status: 0,
        status_id: 0,
        list: [],
        phone: null,
        uid: null,
        p_uid: null,
        data_total: {
          amount_invested: 0,
          escrow_amount: 0,
          total_amount: 0,
          profit: 0,
          profit_margin: 0
        },
        status: [{
          id: 1,
          name: "未完成"
        }, {
          id: 2,
          name: "已完成"
        }],
        timeType: 1,
        PackageType: [{
          id: 1,
          name: "创建时间"
        }, {
          id: 2,
          name: "最后在线时间"
        }],
      }
    },
    updated() {
      form.render();
    },
    mounted() {
      self = this;

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {

        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        laydate = layui.laydate;

        //时间控件
        laydate.render({
          elem: '#order_date',
          range: true
        });

        form.on('switch(rebate)', function(data) {
          var uid = data.elem.dataset.uid,
            isSwitch = 0;
          if (data.elem.checked) {
            isSwitch = 1;
          }
          self.loading = true;
          let param = new URLSearchParams()
          param.append('uid', uid)
          param.append('is_distribution', isSwitch)
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/user_update/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(res) {
            self.loading = false;
            var json = res.data;
            if (json.code == 200) {
              self.ToastFun(0, json.msg); //弹窗提醒
            } else {
              self.ToastFun(1, json.msg); //弹窗提醒
            }
          }).catch(function(error) {
            self.loading = false;
            self.ToastFun(2, error); //弹窗提醒
          })
        });

        //类型
        form.on('select(type_select)', function(data) {
          self.timeType = data.value;
        });

        form.on('select(status_selection)', function(data) {
          var val = $("select[name=status]").val() - 1;
          self.current_status = val;
          var status;
          if (val != -1) {
            status = self.status[self.current_status].id;
          } else {
            status = 0;
          }
          self.status_id = status; //获取当前站点
          self.get_recharge_record(true)
        });
        form.render();

        self.get_recharge_record()
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      get_recharge_record(state) {
        if (state) {
          self.page = 1;
          self.list = [];
        }

        //获取的结束时间自动加一天
        var t = $("#order_date").val();
        var start_time, end_time;
        if (t) {
          self.getDate(t, function(s, e) {
            start_time = s;
            end_time = e;
          })
        }

        self.loading = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        if (start_time) {
          param.append('start_time', start_time)
        }
        if (end_time) {
          param.append('end_time', end_time)
        }
        if (self.uid) {
          param.append('uid', self.uid)
        }
        if (self.p_uid) {
          param.append('p_uid', self.p_uid)
        }
        if (self.phone) {
          param.append('phone', self.phone)
        }
        if (self.timeType) {
          param.append('time_type', self.timeType)
        }
        param.append('status', self.status_id)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/member_list/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if (datas.page) {
              self.count = datas.page.count;
              self.money = datas.page.money;
              self.integral = datas.page.integral;
            }
            if (datas.list) {
              self.list = datas.list;
            } else {
              self.list = [];
            }
            self.ShowPage(self, laypage, "get_recharge_record"); //分页
            $('.pagebox').show();
          }, false);
        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .xblock-row {
    margin-right: 5px;
  }

  .xblock-row input {
    width: 140px;
  }

  .total-data {
    padding: 12px 10px;
    line-height: 18px;
  }

  .total-data-row {
    color: #444;
    padding-right: 30px;
    margin-right: 30px;
    border-right: 1px solid #CCC;
    font-family: Microsoft YaHei, arial;
    font-family: arial;
    font-size: 15px;
  }

  .total-data-row:last-child {
    border-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/Member.vue